export const notFound = {
  title: 'Опачки! Сторінки не знайдено',
  description1: 'Шото пішло не так.',
  description2: 'Здається, посилання неправильне або сторінки більше не існує',
  button: 'Додому',
};
